/*
 * @Author: dongbo 254126189@qq.com
 * @Date: 2023-05-22 14:30:49
 * @LastEditors: dongbo 254126189@qq.com
 * @LastEditTime: 2023-08-08 13:32:57
 * @FilePath: /gwm-pk-h5/src/utils/anrequest.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
import store from "../store";
import router from "../router";
import { sha256 } from "js-sha256";
import Vue from "vue";
import { Toast } from "vant";

import { sourceappver } from "@/utils/getappv"
Vue.use(Toast);
// 创建axios实例
const service = axios.create({
    baseURL: process.env.VUE_APP_URL, // api 的 VUE_APP_URL
    timeout: 50000, // 请求超时时间(因为需要调试后台,所以设置得比较大)
});
axios.defaults.headers["Content-Type"] = "application/json"; //此处是增加的代码，设置请求头的类型

// request拦截器,在请求之前做一些处理
service.interceptors.request.use(
    (config) => {
        let time = Date.now();
        config.headers["SourceApp"] = "PICKUP";
        config.headers["SourceType"] = isIos() ?'IOS':'ANDROID';
        config.headers["AppId"] = process.env.VUE_APP_APPID;
        config.headers["Secret"] = process.env.VUE_APP_SECRET;
        config.headers["TimeStamp"] = time;
        config.headers["SourceAppVer"] = sourceappver.Sourceappver();;
        config.headers["sign"] = sha256(
        time + process.env.VUE_APP_APPID + process.env.VUE_APP_SECRET
        );
        return config;
        
    },
    (error) => {

        Promise.reject(error);

    }
);

// response 拦截器,数据返回后进行一些处理
service.interceptors.response.use(
    (response) => {
        /**
         * code为非20000是抛错 可结合自己业务进行修改
         */
        const res = response.data;
        if (res.code === 0 || res.code === 40102) {
            return res;

        }
        else {
            Promise.reject(res.message);
            Toast.fail(res.message)
            return res
        }
    },
    (error) => {
        Promise.reject("网络异常");
    }
);
var isIos = ()=>{
    var ua = navigator.userAgent.toLowerCase();
    if(/iphone|ipad|ipod/.test(ua)){
      return true
    }else{
      return false
    }
  }
export default service;
